import type { NumberSpeller } from './types'

const ONES = ['ಸೊನ್ನೆ', 'ಒಂದು', 'ಎರಡು', 'ಮೂರು', 'ನಾಲ್ಕು', 'ಐದು', 'ಆರು', 'ಏಳು', 'ಎಂಟು', 'ಒಂಬತ್ತು', 'ಹತ್ತು',
  'ಹನ್ನೊಂದು', 'ಹನ್ನೆರಡು', 'ಹದಿಮೂರು', 'ಹದಿನಾಲ್ಕು', 'ಹದಿನೈದು', 'ಹದಿನಾರು', 'ಹದಿನೇಳು', 'ಹದಿನೆಂಟು', 'ಹತ್ತೊಂಬತ್ತು']
const TENS = ['', '', 'ಇಪ್ಪತ್ತು', 'ಮೂವತ್ತು', 'ನಲವತ್ತು', 'ಐವತ್ತು', 'ಅರವತ್ತು', 'ಎಪ್ಪತ್ತು', 'ಎಂಬತ್ತು', 'ತೊಂಬತ್ತು']
// Tens stem + unit fuse into one word: ಇಪ್ಪತ್ತ + ಾರು = ಇಪ್ಪತ್ತಾರು (26), ಇಪ್ಪತ್ತ + ಮೂರು = ಇಪ್ಪತ್ತಮೂರು (23).
const TENS_STEM = ['', '', 'ಇಪ್ಪತ್ತ', 'ಮೂವತ್ತ', 'ನಲವತ್ತ', 'ಐವತ್ತ', 'ಅರವತ್ತ', 'ಎಪ್ಪತ್ತ', 'ಎಂಬತ್ತ', 'ತೊಂಬತ್ತ']
const ONES_JOIN = ['', 'ೊಂದು', 'ೆರಡು', 'ಮೂರು', 'ನಾಲ್ಕು', 'ೈದು', 'ಾರು', 'ೇಳು', 'ೆಂಟು', 'ೊಂಬತ್ತು']
const HUNDREDS = ['', 'ನೂರು', 'ಇನ್ನೂರು', 'ಮುನ್ನೂರು', 'ನಾನೂರು', 'ಐನೂರು', 'ಆರುನೂರು', 'ಏಳುನೂರು', 'ಎಂಟುನೂರು', 'ಒಂಬೈನೂರು']

function below100(n: number): string {
  if (n < 20) return ONES[n]
  const t = Math.floor(n / 10)
  return n % 10 ? TENS_STEM[t] + ONES_JOIN[n % 10] : TENS[t]
}

/** 250 = ಇನ್ನೂರ ಐವತ್ತು: the hundred drops its final ು when more follows. */
function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  if (!h) return below100(r)
  return r ? `${HUNDREDS[h].slice(0, -1)} ${below100(r)}` : HUNDREDS[h]
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const crore = Math.floor(n / 10_000_000)
  const lakh = Math.floor((n % 10_000_000) / 100_000)
  const thousand = Math.floor((n % 100_000) / 1000)
  const rest = n % 1000
  if (crore) parts.push(`${spell(crore)} ಕೋಟಿ`)
  if (lakh) parts.push(`${below100(lakh)} ${n % 100_000 ? 'ಲಕ್ಷದ' : 'ಲಕ್ಷ'}`)
  if (thousand) {
    const word = rest ? 'ಸಾವಿರದ' : 'ಸಾವಿರ'
    parts.push(thousand === 1 ? word : `${below100(thousand)} ${word}`)
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const kn: NumberSpeller = {
  spell,
  year: spell,
  rupees: 'ರೂಪಾಯಿ'
}
